import EditMemoModal from "@/page/order/AdminOrderDetail/_componant/EditMemoModal";
import { AdminCancelPaymentModal } from "../modal/AdminCancelPaymentModal";
import { OrderStatusModal } from "../modal/OrderStatusModal";
import { PartnerCancelPaymentModal } from "../modal/PartnerCancelPaymentModal";

export const OrderDetailPageModaPanel = () => {
  return (
    <>
      <OrderStatusModal />
      <PartnerCancelPaymentModal />
      <AdminCancelPaymentModal />
      <EditMemoModal />
    </>
  );
};
